// Phai khop `?v=` trong layouts/vueapp.html.erb - helper tu dung path, thieu
// tham so la browser tra lai favicon cu tu cache rieng cua no.
const BAN_ICON = '?v=bonboz1';

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png${BAN_ICON}`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png${BAN_ICON}`;
        favicon.href = oldFileName;
      });
    }
  });
};
